import React, { ReactElement } from 'react';

import SheetContainer, { Content, Overlay, Sheet } from '../../../../../../mobile/structural/sheet';
import { UseSheetReturnType } from '../../../../../../mobile/structural/sheet/hooks/useSheet';
import LabelEditContent from '../edit/LabelEditContent';
import { Label } from '../../../../../../../common/labels/labelTypes';

type LabelEditSheetProps = {
    colorSheetProps: UseSheetReturnType;
    label: Label;
    sheetProps: UseSheetReturnType;
    resetEditingId: () => void;
};

const LabelEditSheet = (props: LabelEditSheetProps): ReactElement => {
    const { colorSheetProps, label, sheetProps, resetEditingId } = props;

    const handleCloseTransitionEnd = () => {
        if (colorSheetProps.isSheetOpen) return;

        // Reset the currently editing label separately from closing the sheet,
        // so that the close animation can run first before the content is removed
        resetEditingId();
    };

    return (
        <SheetContainer className="LabelEditSheet" {...sheetProps} onCloseTransitionEnd={handleCloseTransitionEnd}>
            <Overlay />
            <Sheet>
                <Content>
                    <div className="p-4 pt-2">
                        <LabelEditContent label={label} onColorChangeClick={colorSheetProps.dispatchOpenSheet} />
                    </div>
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default LabelEditSheet;
